import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Sidebar } from './Sidebar'
import { cn, loadingClass } from '../lib/ui'

/**
 * Общий каркас приложения: сайдбар + область контента для вошедших пользователей.
 * Гость на `/` видит только контент дочернего маршрута (форма входа) без сайдбара.
 */
export function AppLayout() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!user) {
    const path = location.pathname
    if (
      path.startsWith('/admin') ||
      path.startsWith('/production') ||
      path.startsWith('/production-requests') ||
      path.startsWith('/planning') ||
      path.startsWith('/inventory') ||
      path.startsWith('/shipments') ||
      path.startsWith('/notifications')
    ) {
      return <Navigate to="/" replace state={{ from: path }} />
    }
    return <Outlet />
  }

  return (
    <div
      className={cn(
        'grid min-h-svh bg-su-page text-su-text-strong',
        'grid-cols-[268px_1fr] max-md:grid-cols-1',
      )}
    >
      <Sidebar />
      <main className="overflow-auto px-8 py-7 max-md:px-5 max-md:py-5">
        <Outlet />
      </main>
    </div>
  )
}
